import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"padding":"0 15px","width":"400px","height":"420px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw600 fs24 centered",
    style: {"color":"#696969"}
  }, "場所情報を編集")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "",
  style: {}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10" }, "登録している場所情報の名称を変更することができます。", -1)
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass(`mt20`)
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  class: /*#__PURE__*/_normalizeClass(`mt20`)
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: /*#__PURE__*/_normalizeClass(`mt20`)
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "fs14 fw600 mt10" }
const _hoisted_18 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`mt20`)
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, [
  /*#__PURE__*/_createTextVNode(" Zoomホストキーは、Zoomにログイン後、"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://zoom.us/profile",
    target: "_blank",
    class: "underline fw600"
  }, "こちらから"),
  /*#__PURE__*/_createTextVNode("確認できます。 ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_22 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "保存", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_26 = {
  key: 0,
  class: "fs14 fw400"
}
const _hoisted_27 = {
  key: 1,
  class: "fs14 fw400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "LocationTagSettingModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll ",
    onBeforeOpen: _ctx.openModal,
    onBeforeClose: _ctx.fadeOutModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
        }, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.loctag.location_type == `offline`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_MdTextfieldTag, {
                    fieldStyle: "min-width:280px;max-width:100%;",
                    style: {"height":"56px","min-width":"280px","max-width":"100%"},
                    class: "fl fs16 text-left",
                    type: `Name`,
                    name: `場所名`,
                    value: _ctx.loctag.keyword,
                    onInputValue: _ctx.inputName,
                    onBlur: _ctx.checkName,
                    errMessage: _ctx.validName ? null : `正しい場所名を入力してください。`,
                    required: ""
                  }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                  _hoisted_10
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_MdTextfieldTag, {
                    fieldStyle: "min-width:280px;max-width:100%;",
                    style: {"height":"56px","min-width":"280px","max-width":"100%"},
                    class: "fl fs16 text-left",
                    type: `email`,
                    name: `住所`,
                    value: _ctx.loctag.address,
                    isDisabled: true,
                    required: ""
                  }, null, 8, ["value"]),
                  _hoisted_12,
                  _createElementVNode("div", {
                    class: "fs14 fw600 mt10 pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkGoogleMap && _ctx.checkGoogleMap(...args)))
                  }, "Googleマップで確認")
                ])
              ]))
            : (_ctx.loctag.location_type == `online`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_MdTextfieldTag, {
                      fieldStyle: "min-width:280px;max-width:100%;",
                      style: {"height":"56px","min-width":"280px","max-width":"100%"},
                      class: "fl fs16 text-left",
                      type: `Name`,
                      name: `場所名`,
                      value: _ctx.loctag.keyword,
                      onInputValue: _ctx.inputName,
                      onBlur: _ctx.checkName,
                      errMessage: _ctx.validName ? null : `正しい場所名を入力してください。`,
                      required: ""
                    }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"]),
                    _hoisted_15
                  ])
                ]))
              : (_ctx.loctag.location_type == `online_oauth`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.loctag.keyword), 1),
                    (_ctx.loctag.provider == `zoom`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_MdTextfieldTag, {
                            fieldStyle: "min-width:280px;max-width:100%;",
                            style: {"height":"56px","min-width":"280px","max-width":"100%"},
                            class: "fl fs16 text-left",
                            type: `text`,
                            name: `Zoomホストキー(数字のみ)`,
                            value: _ctx.loctag.zoom_host_key,
                            errMessage: _ctx.zoomHostkeyErrorMessage,
                            onInputValue: _ctx.inputZoomHostKey
                          }, null, 8, ["name", "value", "errMessage", "onInputValue"]),
                          _hoisted_20
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (true && !_ctx.isPreview)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
              }, _hoisted_24))
            : (_openBlock(), _createElementBlock("section", _hoisted_25, [
                (_ctx.isPreview)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "プレビューのため確定できません"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, "未入力です"))
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onBeforeClose"]))
}